import { orderTestServiceCloud } from "@/services/orderTestRequest";

/**
 * Get patient billing tabs - returns recent orders with billing status
 * @param {Object} params
 * @param {number} params.patient_id - Patient ID (required)
 * @param {number} params.clinic_id - Clinic ID (optional)
 * @param {number} params.limit - Limit number of results (optional, default=20)
 * @returns {Promise} API response with array of billing orders
 */
export function getPatientBillingTabsApi(params) {
  return orderTestServiceCloud({
    url: "/orderTest/getPatientBillingTabs",
    method: "get",
    params,
  });
}

/**
 * Get order items and history by sample ID
 * @param {Object} params
 * @param {number} params.sampleId - Sample ID (required)
 * @returns {Promise} API response with order items and version history
 */
export function getOrderItemsAndHistoryApi(params) {
  return orderTestServiceCloud({
    url: "/orderTest/orderItemsAndHistory",
    method: "get",
    params,
  });
}

/**
 * Get orders created on a specific day
 * @param {Object} params
 * @param {string} params.date - Date in YYYY-MM-DD format (required)
 * @param {boolean} params.include_blood - Filter samples including blood tubes (optional)
 * @returns {Promise} API response with array of sample IDs
 */
export function getOrdersOnDayApi(params) {
  return orderTestServiceCloud({
    url: "/orderTest/orders-on-day",
    method: "get",
    params,
  });
}

/**
 * Get packages and single tests included in an order
 * @param {Object} params
 * @param {number} params.sample_id - Sample ID (required)
 * @returns {Promise} API response with package and test lists
 */
export function getOrderPackageAndTestApi(params) {
  return orderTestServiceCloud({
    url: "/orderTest/getOrderPackageAndTest",
    method: "get",
    params,
  });
}

/**
 * Get questionnaire information of an order
 * @param {Object} params
 * @param {number} params.sampleId - Sample ID (required)
 * @returns {Promise} API response with questionnaire requirements
 */
export function getQuestionnaireRequiredMapApi(params) {
  return orderTestServiceCloud({
    url: "/orderTest/getQuestionnaireRequiredMap",
    method: "get",
    params,
  });
}
